module.exports = __webpack_public_path__ + "static/parfume_4k-7660b8768632d69c4035122b2e82b9b3.webp";